import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Clients } from '../models/clients';
import { Employees } from '../models/employees';

@Injectable({
  providedIn: 'root'
})

export class EmployeesService extends CrudService<Employees, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/employee`);

    this._http = _http;
  }

}

